module.exports = __webpack_public_path__ + "assets/img/ai_word.7a916da8.svg";